/**
 * Walkthrough registry — maps portal versions to slide arrays.
 *
 * To add slides for a new release:
 *   1. Create src/data/walkthroughs/{X.Y.Z}.js exporting a slide array.
 *   2. Import + register it below.
 *   3. Bump VITE_VERSION in .env (drives CURRENT_PORTAL_VERSION).
 */
import { compareVersion } from '../../utils/compareVersion.js';
import { getRoleWeight } from '../../services/session.js';
import slides_4_3_2 from './4.3.2.js';
import slides_4_3_3 from './4.3.3.js';

const WALKTHROUGHS = {
  '4.3.2': slides_4_3_2,
  '4.3.3': slides_4_3_3
};

/**
 * Collect all slides from versions strictly greater than `fromVersion`
 * and less than or equal to `toVersion`, then drop any slides the user
 * does not meet the minimum role weight for.
 *
 * Slides are returned in version order (oldest → newest); within a
 * version, the file's declared order is preserved.
 *
 * @param {string} fromVersion — user's current portal_version (exclusive)
 * @param {string} toVersion   — current portal version (inclusive)
 * @returns {Array<object>} filtered slide array
 */
export function collectSlides(fromVersion, toVersion) {
  const versions = Object.keys(WALKTHROUGHS)
    .filter((v) => compareVersion(v, fromVersion) > 0 && compareVersion(v, toVersion) <= 0)
    .sort(compareVersion);

  const weight = getRoleWeight();
  const slides = [];
  for (const v of versions) {
    for (const slide of WALKTHROUGHS[v]) {
      if (weight >= (slide.minRoleWeight ?? 0)) slides.push(slide);
    }
  }
  return slides;
}
